module.exports = __webpack_public_path__ + "img/guide.4b7ec70f.svg";